import styled from '@emotion/styled';
import {Dialog} from '@mui/material';

export const DialogModal = styled(Dialog)<{
  isFlowSheetScreen: boolean;
  isVitalDataGrid: boolean;
}>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  .MuiDialog-paperFullScreen {
    width: ${({isFlowSheetScreen, isVitalDataGrid}) =>
      isVitalDataGrid && isFlowSheetScreen
        ? '55rem'
        : isFlowSheetScreen
        ? '30rem'
        : ''};
    height: ${({isFlowSheetScreen, isVitalDataGrid}) =>
      isVitalDataGrid && isFlowSheetScreen
        ? '35rem'
        : isFlowSheetScreen
        ? '20rem'
        : ''};
    border-radius: ${({isFlowSheetScreen}) =>
      isFlowSheetScreen ? '0.5rem' : ''};
  }
`;

export const DialogWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
`;
